export const validationGates = [
  {
    id: "source-custody",
    label: "Source Custody",
    rule: "No text is countable unless it has lawful lane, local path, SHA-256, and reproducible extraction output.",
    automated: true
  },
  {
    id: "licensed-boundary",
    label: "Licensed Boundary",
    rule: "Cleary and other modern translations remain bibliographic/source-anchor records until licensed files are supplied.",
    automated: true
  },
  {
    id: "equation-boundary",
    label: "Equation Boundary",
    rule: "Every equation must declare operator-model status, blocked claims, anchors, variables, and feature targets.",
    automated: true
  },
  {
    id: "domain-safety",
    label: "Domain Safety",
    rule: "Trading, legal, medical, and influence features must show their blocked claims and evidence requirements.",
    automated: true
  },
  {
    id: "manual-spot-check",
    label: "Manual Spot Check",
    rule: "Corpus math-context counts require reviewer samples before any full-corpus claim.",
    automated: false
  }
];
